class CustomHttpPostBackend {
  constructor(services, options = {}) {
    this.services = services;
    this.options = options;
  }

  init(services, options = {}) {
    this.services = services;
    this.options = {
      loadPath: '',
      requestPayload: {},
      ...options,
    };
  }

  async read(language, namespace, callback) {
    try {
      const res = await fetch(this.options.loadPath, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...this.options.requestPayload,
        }),
      });

      const json = await res.json();

      const serverTranslations = json?.data?.translation;

      if (!serverTranslations) {
        return callback(new Error('Server did not return translation'), false);
      }

      return callback(null, serverTranslations);
    } catch (err) {
      return callback(err, false);
    }
  }
}

CustomHttpPostBackend.type = 'backend';

export default CustomHttpPostBackend;
